import { Center } from "@chakra-ui/react";
import * as React from 'react';
export default {
  Center,
  React
};